export default "__VITE_ASSET__D5hH3NCb__"